import {
  IShowResultsPanelAction,
  ResultsActionEnum,
  IHideResultsPanelAction,
  IFetchAuctionResultsSuccessAction,
  IFetchAuctionResultsFailedAction,
  IFetchAuctionResultsAction,
} from ".";
import { IAuction, IProductResult } from "../../services";

export const ShowResultsPanelAction = (auction: IAuction) => {
  return {
    type: ResultsActionEnum.ShowResultsPanel,
    state: {
      showResultsPanel: true,
      auctionResultsName: auction.auctionName,
      identification: auction.identification,
    },
  } as IShowResultsPanelAction;
};

export const HideResultsPanelAction = () => {
  return {
    type: ResultsActionEnum.HideResultsPanel,
    state: {
      showResultsPanel: false,
    },
  } as IHideResultsPanelAction;
};

export const FetchAuctionResultsAction = (identification: string) => {
  return {
    type: ResultsActionEnum.FetchAuctionResults,
    state: {
      identification,
      isLoading: true,
    },
  } as IFetchAuctionResultsAction;
};

export const FetchAuctionResultsSuccessAction = (results: IProductResult[]) => {
  return {
    type: ResultsActionEnum.FetchAuctionResultsSuccess,
    state: {
      auctionProductResults: results,
      isLoading: false,
      errorMessage: "",
    },
  } as IFetchAuctionResultsSuccessAction;
};

export const FetchAuctionResultsFailedAction = (errorMessage: string) => {
  return {
    type: ResultsActionEnum.FetchAuctionResultsFailed,
    state: {
      errorMessage,
      isLoading: false,
    },
  } as IFetchAuctionResultsFailedAction;
};